<template>
  <div class="join-event">
    <join-event-template  :awardsSetImg="awardsSetImg" :applyImg="applyImg" :id="id" :swiperImg="swiperImg"
      :eventDetail="eventDetail"></join-event-template>
  </div>
</template>
<script>
  import joinEventTemplate from "../../components/joinEventTemplate";
  import {
    imgUrl
  } from "../../utils/config";
  export default {
    data() {
      return {
        // 模板id
        id: 2,
        // 轮播图
        swiperImg: [{
            id: 1,
            imgUrl: imgUrl + "view/joinEvent/img/banner_cosmetics_1.jpg",
            href: "http://www.hsgchina.com/mobile/download/download"

          },
          {
            id: 2,
            imgUrl: imgUrl + "view/joinEvent/img/banner_photo.jpg",
            href: "https://event.kongquechao.com/view/joinEvent/#/joinPhotographyEvent",

          }
        ],
        // 大赛详情图片
        eventDetail: [{
            id: 1,
            imgUrl: imgUrl + "view/joinEvent/img/cosmetics_1.jpg",
          },
          {
            id: 2,
            imgUrl: imgUrl + "/view/joinEvent/img/cosmetics_2.jpg",
          },
          {
            id: 3,
            imgUrl: imgUrl + "view/joinEvent/img/cosmetics_3.jpg",
          },
          {
            id: 4,
            imgUrl: imgUrl + "view/joinEvent/img/cosmetics_4_4.jpg",
          }
        ],
        // 奖项设置图片
        awardsSetImg: imgUrl + "/view/joinEvent/img/cosmetics_2.jpg",
        // 报名方式图片
        applyImg: imgUrl + "view/joinEvent/img/cosmetics_3.jpg"
      }
    },
    components: {
      // 活动模板
      joinEventTemplate,
    }
  }
</script>

<style lang="less" scoped>

</style>